import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICompany, ICompanyState } from './models';
import { getCompanies } from 'src/services/company';
import { RootState } from '../store';
import { useAppSelector } from '../hooks';

const initialState: ICompanyState = {
  companiesList: [],
  isFetching: false
};

// --- Define thunk ---
export const getCompaniesAsync = createAsyncThunk<ICompany[], void>(
  'companies/fetchAll',
  async () => {
    const { data } = await getCompanies({
      limit: 0,
      page: 1,
      hide_product_management: 1
    });
    return data;
  }
);

export const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompaniesAsync.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(
        getCompaniesAsync.fulfilled,
        (state, action: PayloadAction<ICompany[]>) => {
          state.isFetching = false;
          state.companiesList = action.payload; // Replace with the full list of companies
        }
      )
      .addCase(getCompaniesAsync.rejected, (state) => {
        state.isFetching = false;
      });
  }
});

export const useGetCompaniesState = () =>
  useAppSelector((state: RootState) => state[companiesSlice.name]);

// --- Export actions and the reducer ---
export const CompaniesReducer = companiesSlice.reducer;
export default CompaniesReducer;
